import { createRouter, createWebHashHistory } from 'vue-router'
import staticRoutes from './routes'
import { setupRouterGuard } from './guard'

const router = createRouter({
  history: createWebHashHistory(import.meta.env.VITE_BASE_URL || '/'),
  routes: staticRoutes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) return savedPosition
    return { top: 0, behavior: 'smooth' }
  }
})

setupRouterGuard(router)

export function resetRouter(): void {
  const newRouter = createRouter({
    history: createWebHashHistory(import.meta.env.VITE_BASE_URL || '/'),
    routes: staticRoutes
  })
  ;(router as unknown as { matcher: unknown }).matcher = (
    newRouter as unknown as { matcher: unknown }
  ).matcher
}

export default router
